import React from "react";
import {
	Button,
	FormGroup,
	FormInput,
	ListGroup,
	ListGroupItem,
	ListGroupItemHeading,
	ListGroupItemText,
	Nav,
	Navbar,
	NavItem,
	NavLink,
} from "shards-react";

class FooterBar extends React.PureComponent {
	footerMenus = () => {
		return (
			<React.Fragment>
				<Nav navbar className="d-flex justify-content-between w-50">
					<NavItem>
						<NavLink active href="#">
							<img alt=""
								 src="data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiA/PjwhRE9DVFlQRSBzdmcgIFBVQkxJQyAnLS8vVzNDLy9EVEQgU1ZHIDEuMS8vRU4nICAnaHR0cDovL3d3dy53My5vcmcvR3JhcGhpY3MvU1ZHLzEuMS9EVEQvc3ZnMTEuZHRkJz48c3ZnIGhlaWdodD0iNTEycHgiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDUxMiA1MTI7IiB2ZXJzaW9uPSIxLjEiIHZpZXdCb3g9IjAgMCA1MTIgNTEyIiB3aWR0aD0iNTEycHgiIHhtbDpzcGFjZT0icHJlc2VydmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPjxnIGlkPSJjb21wX3g1Rl8zNDQtdHdpdHRlcl90Ij48Zz48ZyBpZD0iX3gzMl82LXR3aXR0ZXJfeDJDX190d2VldF81XyI+PGc+PGc+PHBhdGggZD0iTTM3MC42ODgsMzcwLjk5NEgyNTZjLTMxLjYyNSwwLTU3LjM0Mi0yNS43ODMtNTcuMzQyLTU3LjQ5NnYtMjguNzU2aDE3Mi4wM2MzMS42NTQsMCw1Ny4zNDEtMjUuNzU2LDU3LjM0MS01Ny40OTYgICAgICAgcy0yNS42ODgtNTcuNS01Ny4zNDEtNTcuNWgtMTcyLjAzVjgzLjVjMC0zMS43MzgtMjUuNjktNTcuNS01Ny4zNDctNTcuNUMxMDkuNjYxLDI2LDgzLjk3LDUxLjc2Miw4My45Nyw4My41djIyOS45OTggICAgICAgQzgzLjk3LDQwOC42MzEsMTYxLjEyNiw0ODYsMjU2LjAwMiw0ODZoMTE0LjY4OWMzMS42NTEsMCw1Ny4zMzktMjUuNzY2LDU3LjMzOS01Ny41MDQgICAgICAgQzQyOC4wMjksMzk2Ljc2LDQwMi4zNDIsMzcwLjk5NCwzNzAuNjg4LDM3MC45OTRMMzcwLjY4OCwzNzAuOTk0eiIvPjwvZz48L2c+PC9nPjwvZz48L2c+PGcgaWQ9IkxheWVyXzEiLz48L3N2Zz4=" />
						</NavLink>
					</NavItem>
					<NavItem>
						<NavLink href="#">
							<img alt=""
								 src="data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiA/PjwhRE9DVFlQRSBzdmcgIFBVQkxJQyAnLS8vVzNDLy9EVEQgU1ZHIDEuMS8vRU4nICAnaHR0cDovL3d3dy53My5vcmcvR3JhcGhpY3MvU1ZHLzEuMS9EVEQvc3ZnMTEuZHRkJz48c3ZnIGhlaWdodD0iNTEycHgiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDUxMiA1MTI7IiB2ZXJzaW9uPSIxLjEiIHZpZXdCb3g9IjAgMCA1MTIgNTEyIiB3aWR0aD0iNTEycHgiIHhtbDpzcGFjZT0icHJlc2VydmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPjxnIGlkPSJjb21wX3g1Rl8zMzUtdGVsZWdyYW0iPjxnPjxwYXRoIGQ9Ik00ODQuNjg5LDk4LjIzMWwtNjkuNDE3LDMyNy4zN2MtNS4yMzcsMjMuMTA1LTE4Ljg5NSwyOC44NTQtMzguMzA0LDE3Ljk3MkwyNzEuMiwzNjUuNjMxbC01MS4wMzQsNDkuMDg2ICAgIGMtNS42NDcsNS42NDctMTAuMzcyLDEwLjM3Mi0yMS4yNTYsMTAuMzcybDcuNTk4LTEwNy43MjJMNDAyLjUzOSwxNDAuMjNjOC41MjMtNy41OTgtMS44NDgtMTEuODA5LTEzLjI0Ny00LjIxTDE0Ni45NSwyODguNjE0ICAgIEw0Mi42MTksMjU1Ljk2Yy0yMi42OTQtNy4wODYtMjMuMTA0LTIyLjY5NSw0LjcyMy0zMy41NzlMNDU1LjQyMyw2NS4xNjZDNDc0LjMxNiw1OC4wODEsNDkwLjg1LDY5LjM3NSw0ODQuNjg5LDk4LjIzMXoiLz48L2c+PC9nPjxnIGlkPSJMYXllcl8xIi8+PC9zdmc+" />
						</NavLink>
					</NavItem>
					<NavItem>
						<NavLink href="#">
							<img alt=""
								 src="data:image/svg+xml;base64,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" />
						</NavLink>
					</NavItem>
					<NavItem>
						<NavLink href="#">
							<img alt=""
								 src="data:image/svg+xml;base64,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" />
						</NavLink>
					</NavItem>
					<NavItem>
						<NavLink href="#">
							<img alt=""
								 src="data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiA/PjxzdmcgaGVpZ2h0PSIxNzkyIiB2aWV3Qm94PSIwIDAgMTc5MiAxNzkyIiB3aWR0aD0iMTc5MiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNTk3IDQyMXYxMTczcTAgMjUtMTIuNSA0Mi41dC0zNi41IDE3LjVxLTE3IDAtMzMtOGwtNDY1LTIzM3EtMjEtMTAtMzUuNS0zMy41dC0xNC41LTQ2LjV2LTExNDBxMC0yMCAxMC0zNHQyOS0xNHExNCAwIDQ0IDE1bDUxMSAyNTZxMyAzIDMgNXptNjQgMTAxbDUzNCA4NjYtNTM0LTI2NnYtNjAwem0xMTMxIDE4djEwNTRxMCAyNS0xNCA0MC41dC0zOCAxNS41LTQ3LTEzbC00NDEtMjIwem0tMy0xMjBxMCAzLTI1Ni41IDQxOS41dC0zMDAuNSA0ODcuNWwtMzkwLTYzNCAzMjQtNTI3cTE3LTI4IDUyLTI4IDE0IDAgMjYgNmw1NDEgMjcwcTQgMiA0IDZ6Ii8+PC9zdmc+" />
						</NavLink>
					</NavItem>
				</Nav>
			</React.Fragment>
		);
	};

	render() {
		return (
			<footer>
				<Navbar className="d-flex justify-content-center p-0">
					<section
						className="footer-menu d-flex flex-lg-row flex-md-row flex-sm-column justify-content-around">
						<ListGroup>
							<ListGroupItem className="curved-copyright-header py-0">
								<h2 className="my-0 logo-title float-left">
									<span>MUSIC</span>
									<br />
									<span className="text-moving">MOVING</span>
								</h2>
							</ListGroupItem>
							<ListGroupItem className="curved-copyright-text py-0">
								<ListGroupItemText>
									<span>&copy; 2022 Music Moving&trade;</span>
								</ListGroupItemText>
							</ListGroupItem>
						</ListGroup>
						<ListGroup>
							<ListGroupItem className="py-sm-0 py-lg-3">
								<ListGroupItemHeading className="font-weight-bold mb-4">Company</ListGroupItemHeading>
								<ListGroupItemText>
									Help Center
								</ListGroupItemText>
								<ListGroupItemText>
									Support
								</ListGroupItemText>
								<ListGroupItemText>
									Jobs
								</ListGroupItemText>
								<ListGroupItemText>
									Privacy
								</ListGroupItemText>
								<ListGroupItemText>
									Terms of Service
								</ListGroupItemText>
								<ListGroupItemText>
									Associated Risks
								</ListGroupItemText>
							</ListGroupItem>
						</ListGroup>
						<ListGroup>
							<ListGroupItem className="py-sm-0 py-lg-3">
								<ListGroupItemHeading
									className="font-weight-bold d-lg-block d-md-block d-sm-none mb-4">&nbsp;</ListGroupItemHeading>
								<ListGroupItemText>
									Music Moving Network
								</ListGroupItemText>
								<ListGroupItemText>
									Music Moving Academy
								</ListGroupItemText>
								<ListGroupItemText>
									Music Moving Premium
								</ListGroupItemText>
							</ListGroupItem>
						</ListGroup>
						<ListGroup>
							<ListGroupItem>
								<ListGroupItemHeading className="font-weight-bold mb-4">Social</ListGroupItemHeading>
								<ListGroupItemText>
									Twitter
								</ListGroupItemText>
								<ListGroupItemText>
									Telegram
								</ListGroupItemText>
								<ListGroupItemText>
									Discord
								</ListGroupItemText>
								<ListGroupItemText>
									Github
								</ListGroupItemText>
								<ListGroupItemText>
									Medium
								</ListGroupItemText>
								{/*<ListGroupItemText tag="div">
									<FormGroup className="contact-form d-flex justify-content-between">
										<FormInput className="w-75" size="sm" placeholder="Email Address" type="number" />
										<Button className="w-25 py-0 ml-2">Send</Button>
									</FormGroup>
								</ListGroupItemText>*/}
							</ListGroupItem>
						</ListGroup>
					</section>
				</Navbar>
			</footer>
		);
	}
}

export default FooterBar;
